import { appointmentTypeActionTypes } from './../constants/ApiConstants';

const initialState = {
  appointmentTypeList: null,
  appointmentTypeDetail: null,
  saved_appointmentType: null,
  deleted_AppointmentType: null,
  master_Data: null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case appointmentTypeActionTypes.save_appointmentType.REQUEST:
    return {
      ...state,
      loading: true,
      saved_appointmentType: null,
    };
  case appointmentTypeActionTypes.save_appointmentType.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_appointmentType: payload,
    };
  case appointmentTypeActionTypes.get_appointmentTypeList.REQUEST:
    return {
      ...state,
      loading: true,
      appointmentTypeList: null,
    };
  case appointmentTypeActionTypes.get_appointmentTypeList.SUCCESS:
    return {
      ...state,
      loading: false,
      appointmentTypeList: payload,
    };
  case appointmentTypeActionTypes.get_appointmentTypeDetail.REQUEST:
    return {
      ...state,
      loading: true,
      appointmentTypeDetail: null,
    };
  case appointmentTypeActionTypes.get_appointmentTypeDetail.SUCCESS:
    return {
      ...state,
      loading: false,
      appointmentTypeDetail: payload,
    };
  case appointmentTypeActionTypes.delete_appointmentType.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_AppointmentType: null,
    };
  case appointmentTypeActionTypes.delete_appointmentType.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_AppointmentType: payload,
    };
  case appointmentTypeActionTypes.get_masterData.REQUEST:
    return {
      ...state,
      loading: true,
      master_Data: null,
    };
  case appointmentTypeActionTypes.get_masterData.SUCCESS:
    return {
      ...state,
      loading: false,
      master_Data: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/appointment-type/reducers/AppointmentTypeReducer.js